<template>
  <div v-if="accepting">
    <h1 class="font-bold text-3xl">
      <base-loading class="text-3xl mr-4" /> Confirming account
    </h1>
  </div>
  <div v-else>
    <h1 v-if="error" class="text-red-600 font-bold text-4xl leading-tight mb-8">
      Token incorrect or account already confirmed!
    </h1>
    <h1 v-else class="text-green-400 font-bold text-3xl leading-tight mb-8">
      Your account is now active!
    </h1>
    <router-link
      to="/login"
      class="inline-block text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Log in
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accepting: false,
      error: false,
    };
  },
  created() {
    this.acceptInvitation();
  },
  methods: {
    async acceptInvitation() {
      try {
        this.accepting = true;
        await this.$api.post(`rest-auth/registration/verify-email/`, {
          key: this.$route.params.token,
        });
        this.$router.push({ name: 'login' });
      } catch (error) {
        this.error = true;
      } finally {
        this.accepting = false;
      }
    },
  },
};
</script>
